
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claims",
      function () {
        return require("private-next-pages/claims/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claims"])
      });
    }
  